import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DealerLunchShiftModel, DealerLunchShiftRequestModel, DealerOpeningHoursViewModel } from 'projects/Administration/src/app/business-entities/dealer-opening-hours-view-model';
import { DealerWorkingHoursBusinessService } from 'projects/Administration/src/app/business-services/dealer-working-hours.service';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as fromEnums from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { Utility } from '../../../../../../../Autofacets-Core/src/app/utils/utility';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Constant } from '../../../../../../../Autofacets-Core/src/app/utils/constant';
import { TranslateService } from '@ngx-translate/core';
import { OccasionalShiftSaveViewModel } from '../../../../business-entities/occasionalshift-save-view-model';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';

@Component({
    selector: 'app-edit-dealer-working-hours',
    templateUrl: 'edit-dealer-working-hours.component.html',
    styleUrls: ['./edit-dealer-working-hours.component.css']
})
export class EditDealerWorkingHoursComponent implements OnInit {


    @Input() dealerId: string;
    dealerWorkingHours: DealerOpeningHoursViewModel[];
    allowedTimesForSlotFrom: string[][] = [];
    allowedTimesForSlotTo: string[][] = [];
    allTimeStamps: string[] = [];
    zeroTime = '00:00';
    isDealerLoggedIn: boolean;
    addOccasionalShiftForm: FormGroup;
    startdate: string;
    enddate: string;
    OccasionList:OccasionalShiftSaveViewModel[]=[];
    SelectedRadioButton:any = 1;
    isDisable:boolean = false;
    isDatesDisable:boolean = false;
    isDelete:boolean = false;
    popupCloseResult = false;
    
    lunchShift: DealerLunchShiftModel = {
      id: 0,
      startTime: '00:00',
      endTime: '00:00',
      startTimeBreak1: '00:00',
      endTimeBreak1: '00:00',
      startTimeBreak2: '00:00',
      endTimeBreak2: '00:00',
      startTimeDate: null,
      endTimeDate: null,
      break1StartTimeDate: null,
      break1EndTimeDate: null,
      break2StartTimeDate: null,
      break2EndTimeDate: null,
      lunchStartTime: { hour:0, minute: 0 },
      lunchEndTime: { hour:0, minute: 0 },
      break1StartTime: { hour:0, minute: 0 },
      break1EndTime: { hour:0, minute: 0 },
      break2StartTime: { hour:0, minute: 0 },
      break2EndTime: { hour:0, minute: 0 },
    };
    addLunchShift: DealerLunchShiftRequestModel = {
      id: null,
      dealerId: null,
      startTimeDate: '00:00',
      endTimeDate: '00:00',
      break1StartTimeDate: '00:00',
      break1EndTimeDate: '00:00',
      break2StartTimeDate: '00:00',
      break2EndTimeDate: '00:00',
    };
    originalDealerWorkingHours: DealerOpeningHoursViewModel[];
    originalLunchShift: DealerLunchShiftModel;
    
    constructor(
        private decimalPipe: DecimalPipe,
        private dealerWorkingHoursService: DealerWorkingHoursBusinessService,
        private toastr: ToastrService,
        private spinner: NgxSpinnerService,
        private activeModal : NgbActiveModal,
        private userService: UserDataService,
        private formBuilder: FormBuilder,
        private translate: TranslateService,
        private cdrf:ChangeDetectorRef,
        private modalService: NgbModal,
    ) {
    }

    async ngOnInit() {
        this.isDealerLoggedIn = this.userService.currentUserValue.roleType === fromEnums.UserRoles.DealerAdmin;
        this.addOccasionalShiftForm = this.formBuilder.group({
            occasionname: ['', [Validators.required]],
            startdate: ['', [Validators.required]],
            enddate: ['',[Validators.required]],
          });
        await this.getOccasionList();
        this.ChangeOccasion();
    }
    async getOccasionList(){
        this.cdrf.detectChanges();
        await this.dealerWorkingHoursService.GetSpecialOccasionList(this.dealerId).then((response) => {
            this.OccasionList = response.responseObject;
            this.cdrf.detectChanges();
        })
    }
    ChangeOccasion(){
        this.cdrf.detectChanges();
        let SelectedInput = this.OccasionList.filter(x => x.rowId == this.SelectedRadioButton);
        this.startdate = (SelectedInput[0].startDate)?Utility.GetFormattedDate(SelectedInput[0].startDate):null;
        this.enddate = (SelectedInput[0].endDate)?Utility.GetFormattedDate(SelectedInput[0].endDate):null;
        this.addOccasionalShiftForm.patchValue({
            occasionname:SelectedInput[0].occasionName
        })
        this.isDisable = true;
        if(this.SelectedRadioButton == 1){
            this.isDatesDisable = true;
            this.isDelete = false;
        }
        else {
            this.isDatesDisable = false;
            if(Utility.getDateStringToDate(this.startdate) > new Date()){
                this.isDelete = true;
            }
            else{
                this.isDelete = false;
            }
        }
        this.cdrf.detectChanges();
        this.getAll();
    }
    OnClear(){
        this.startdate = null;
        this.enddate= null;
        this.addOccasionalShiftForm.patchValue({
            occasionname:'',
            startdate:null,
            enddate:null
        });
        this.isDisable = false;
        this.SelectedRadioButton = 0;
        this.isDatesDisable = false;
        this.isDelete = false;
    }
    OnDelete(){
    let occasionalShiftDeleteViewModel=
    {
        rowId: this.SelectedRadioButton,
        dealerId:this.dealerId
    }
    let modelHeadermsg = this.translate.instant("lblDeleteSpecialOccasion");
    let modelBodymsg = this.translate.instant("lblSureToDeleteSpecialOccasion");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
        // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.dealerWorkingHoursService.DeleteSpecialOccasion(occasionalShiftDeleteViewModel).then((response) => {
            if (response.responseCode === Constant.SuccessResponseCode) {
                if(!response.responseObject.isSuccess){
                    let errorMsg = this.translate.instant('lblPlanningDoneSpecialOccasionNotDeleted');
                    this.toastr.error(errorMsg);
                }
                else{
                        let successMsg = this.translate.instant('lblSuccesfullyDeletedSpecialOccasion');
                        this.toastr.success(successMsg);
                        this.SelectedRadioButton = 1;
                        this.getOccasionList();
                        this.ChangeOccasion();
                    }
                }
                this.spinner.hide();
            });
      }
    });
}
private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
    get cpf() {
        return this.addOccasionalShiftForm.controls;
      }

      async AddOccasionalShift(){
          this.cdrf.detectChanges();
        if (this.addOccasionalShiftForm.invalid) {
            return;
        }
        let endDate = Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addOccasionalShiftForm.value.enddate))
        let startDate = Utility.ConvertLocalDateToUTCDate(Utility.getDateStringToDate(this.addOccasionalShiftForm.value.startdate))
        let occasionalShiftSaveViewModel=
        {
            rowId: this.SelectedRadioButton,
            occasionName: this.addOccasionalShiftForm.value.occasionname,
            startDate: startDate,
            endDate: endDate,
            dealerId:this.dealerId
        }
        if (this.validateDateTime(new Date(startDate),new Date(endDate)))
        {
            await this.dealerWorkingHoursService.AddEditSpecialOccasion(occasionalShiftSaveViewModel).then(async (response) => {
                if (response.responseCode === Constant.SuccessResponseCode) {
                    if(!response.responseObject.isSuccess){
                        let errorMsg = this.translate.instant('lblClashingDate');
                        this.toastr.error(errorMsg);
                    }
                    else{
                        if(this.SelectedRadioButton == 0) {
                            this.toastr.success(Constant.SuccessfullyAdded);
                            await this.getOccasionList();
                            this.SelectedRadioButton = parseInt(response?.responseObject?.retValue);
                            this.ChangeOccasion();
                        }

                        else {
                            let successMsg = this.translate.instant('lblSuccesfullyEdited');
                            this.toastr.success(successMsg);
                            this.getOccasionList();
                        }
                    }
                }
            });
        }
      }
      validateDateTime(startDate:Date,endDate:Date)
      {
          if(endDate<startDate)
          {
              this.toastr.error(Constant.DateRangeValidation);
              return false;
          }
          return true;
      }

    async getAll() {
        await this.getDealerWorkingHours();
        await this.GetDealerLunchShiftDetails();
        this.initializeAllTimeStamps();
        this.manageAllowedTimeStamps();
        }

    manageAllowedTimeStamps(): void {
        this.manageAllowedTimeStampsForSlotFromInput();
        this.manageAllowedTimeStampsForSlotToInput();
    }

    manageAllowedTimeStampsForSlotToInput(): void {
        this.dealerWorkingHours.forEach((workingHours, index) => {
            const openingTimeInHours = workingHours.openingTimeHrs;
            if (openingTimeInHours === this.zeroTime) {
                this.allowedTimesForSlotTo[index] = this.allTimeStamps;
            } else {
                this.setAllowedClosingTime(index, openingTimeInHours);
            }
        });
    }

    manageAllowedTimeStampsForSlotFromInput(): void {
        this.dealerWorkingHours.forEach((workingHours, index) => {
            const closingTimeInHours = workingHours.closingTimeHrs;
            if (closingTimeInHours === this.zeroTime) {
                this.allowedTimesForSlotFrom[index] = this.allTimeStamps;
            } else {
                this.setAllowedOpeningTime(index, closingTimeInHours);
            }
        });
    }

    onChangeOpeningHours(index: number, time: any): void {
        this.dealerWorkingHours[index].openingTimeHrs = (time.hour.toString().length===1? ("0"+time.hour) : time.hour) + ":" + (time.minute.toString().length===1? ("0"+time.minute) : time.minute) +":"+  (time.second.toString().length===1? ("0"+time.second) : time.second) ;
        this.setAllowedClosingTime(index, this.dealerWorkingHours[index].openingTimeHrs);
        if (this.dealerWorkingHours[index].closingTimeHrs === this.zeroTime) {
            const openingTimeIndex = this.allTimeStamps.findIndex(x => x === this.dealerWorkingHours[index].openingTimeHrs);
            const minClosingTimeIndex = openingTimeIndex + 1;
            this.dealerWorkingHours[index].closingTimeHrs = this.allTimeStamps[minClosingTimeIndex];
        }
    }


    onChangeClosingHours(index: number, time: any): void {
        let timeValue=(time.hour.toString().length===1? ("0"+time.hour) : time.hour) + ":" + (time.minute.toString().length===1? ("0"+time.minute) : time.minute) +":"+  (time.second.toString().length===1? ("0"+time.second) : time.second) ;
        this.dealerWorkingHours[index].closingTimeHrs = timeValue;
        this.setAllowedOpeningTime(index, timeValue);
    }

    setAllowedOpeningTime(index: number, closingTime: string): void {
        const closingTimeIndex = this.allTimeStamps.findIndex(x => x === closingTime);
        this.allowedTimesForSlotFrom[index] = closingTimeIndex > -1 ? this.allTimeStamps.slice(0, closingTimeIndex) : this.allTimeStamps.slice();
    }

    setAllowedClosingTime(index: number, openingTime: string): void {
        const openingTimeIndex = this.allTimeStamps.findIndex(x => x === openingTime);
        this.allowedTimesForSlotTo[index] = openingTimeIndex > -1 ? this.allTimeStamps.slice(openingTimeIndex + 1) : this.allTimeStamps.slice();
    }

    initializeAllTimeStamps(): void {
        const totalHoursInDay = 24;
        const totalMinsInHour = 60;
        const timeDifferenceInMins = 15;
        for (let i = 0; i < totalHoursInDay; i++) {
            for (let j = 0; j < totalMinsInHour; j += timeDifferenceInMins) {
                const time = `${this.decimalPipe.transform(i, '2.0-0')}:${this.decimalPipe.transform(j, '2.0-0')}`;
                this.allTimeStamps.push(time);
            }
        }
        this.dealerWorkingHours.forEach(()=>{
            this.allowedTimesForSlotFrom.push(this.allTimeStamps.slice());
            this.allowedTimesForSlotTo.push(this.allTimeStamps.slice());
        })
    }

    onUpdateDelaerShift(isSaveAndClose): void {
        let isLunchUpdated = this.hasLunchShiftChanged();
        let isShiftUpdated = this.getUpdatedDays().length > 0;

        if (!isShiftUpdated && !isLunchUpdated) {
            this.toastr.info(this.translate.instant('lblNoChangesDetected'));
            if (isSaveAndClose) {
                this.activeModal.close({ success: true });
            }
            return;
        }
        else{
            let modelHeadermsg = this.translate.instant("lblAreYouSureWantToUpdateMechanicShift");
            let modelBodymsg = this.translate.instant("lblSureWantToUpdateMechanicShift");
            const modalRef = this.modalService.open(NgbdModalContent);
            modalRef.componentInstance.modelHeader = modelHeadermsg;
            modalRef.componentInstance.modelBody = modelBodymsg;
            modalRef.result.then((_result) => {
            }, (reason) => {
                let isUpdatedLunch = isLunchUpdated ? 1 : 0;
                this.onSaveChanges(isSaveAndClose, reason, isUpdatedLunch);
             });
        }
    }

    validateWorkingHours(workingDays:any): string | null {
        for (const workingHours of workingDays) {
            const openingMins = (workingHours.openingTime?.hour ?? 0) * 60 + (workingHours.openingTime?.minute ?? 0);
            const closingMins = (workingHours.closingTime?.hour ?? 0) * 60 + (workingHours.closingTime?.minute ?? 0);

            if (openingMins >= closingMins) {
                let erromessage = this.translate.instant('lblOpeningTimeMustBeBeforeClosingTime');
                erromessage = erromessage.replace('{Day}', workingHours.day);
                return erromessage;
            }
        }
        return null;
    }

    getUpdatedDays(): DealerOpeningHoursViewModel[] {
        const updatedDays: DealerOpeningHoursViewModel[] = [];

        this.dealerWorkingHours.forEach((current, index) => {
            const original = this.originalDealerWorkingHours[index];

            const hasChanged =
                current.open !== original.open ||
                current.openingTime?.hour !== original.openingTime?.hour ||
                current.openingTime?.minute !== original.openingTime?.minute ||
                current.closingTime?.hour !== original.closingTime?.hour ||
                current.closingTime?.minute !== original.closingTime?.minute;

            if (hasChanged) {
                updatedDays.push(current);
            }
        });

        return updatedDays;
    }

    hasLunchShiftChanged(): boolean {
        if (!this.originalLunchShift) {
            return false;
        }

        return this.lunchShift.startTime !== this.originalLunchShift.startTime ||
            this.lunchShift.endTime !== this.originalLunchShift.endTime ||
            this.lunchShift.startTimeBreak1 !== this.originalLunchShift.startTimeBreak1 ||
            this.lunchShift.endTimeBreak1 !== this.originalLunchShift.endTimeBreak1 ||
            this.lunchShift.startTimeBreak2 !== this.originalLunchShift.startTimeBreak2 ||
            this.lunchShift.endTimeBreak2 !== this.originalLunchShift.endTimeBreak2;
    }

    onSaveChanges(isSaveAndClose, isUpdateMechanicShift, isUpdatedLunch): void {
        this.setDefaultSlotTimeWhenNotWorking();
        this.spinner.show();

        let updatedDays = isUpdatedLunch === 1 ? this.dealerWorkingHours : this.getUpdatedDays();
        const validationError = this.validateWorkingHours(updatedDays);
        if (validationError) {
            this.toastr.error(validationError);
            this.spinner.hide();
            return;
        }
        this.addLunchShift.id = this.lunchShift.id;
        this.addLunchShift.dealerId = this.dealerId;
        this.addLunchShift.startTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTime);
        this.addLunchShift.endTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTime);
        this.addLunchShift.break1StartTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTimeBreak1);
        this.addLunchShift.break1EndTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTimeBreak1);
        this.addLunchShift.break2StartTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.startTimeBreak2);
        this.addLunchShift.break2EndTimeDate = Utility.ConvertLocalTimeToDateTime(this.lunchShift.endTimeBreak2);

        let shiftModel = JSON.parse(JSON.stringify(updatedDays));
        shiftModel.forEach(element => {
            let openingTime=element.openingTime.hour + ":" + element.openingTime.minute;
            let closingTime=element.closingTime.hour + ":" + element.closingTime.minute;
            element.openingTimeHrs= Utility.ConvertLocalTimeToDateTime(openingTime);
            element.closingTimeHrs=Utility.ConvertLocalTimeToDateTime(closingTime);
            element.occasionId = this.SelectedRadioButton;
            element.openingTime=null;
            element.closingTime=null;
        });
        let viewModel =
        {
            dealerOpeningHoursViewModel: shiftModel,
            dealerLunchShiftModel: this.addLunchShift,
            isUpdateMechanicShift: isUpdateMechanicShift,
            isUpdatedLunch: isUpdatedLunch
        }
        this.dealerWorkingHoursService.updateDealerWorkingHours(viewModel).then((response) => {
            let result = response.responseObject;
            if (result.isSuccess) {
                this.toastr.success(fromEnums.ToastrMessages.DealerWorkingHoursUpdated);
            } else {
                if(result.retValue == '-8000'){
                    let errMsg = this.translate.instant('lblPlanningDoneCantUpdate');
                    this.toastr.error(errMsg);
                }
                else if(result.retValue == fromEnums.ErrorCodes.DealerBreak){
                    let errMsg = this.translate.instant('lblInvalidBreakTimings');
                    this.toastr.error(errMsg);
                }
                else{
                    let errMsg = this.translate.instant('lblDealerShouldBeWorking') + ' ' + this.dealerWorkingHours.filter(x => x.dayNumber == parseInt(result.retValue))[0].day;
                    this.toastr.error(errMsg);
                }
            }
            this.getDealerWorkingHours();
            this.spinner.hide();
            if(isSaveAndClose)
             this.activeModal.close({ success: true });

        });
    }

    setDefaultSlotTimeWhenNotWorking() {
        this.dealerWorkingHours.forEach(workingHours => {
            if (!workingHours.open) {
                workingHours.openingTimeHrs = this.zeroTime;
                workingHours.closingTimeHrs = this.zeroTime;
            }
        })
    }

    async getDealerWorkingHours() {
        this.spinner.show();
        this.dealerWorkingHours = await this.dealerWorkingHoursService.getDealerWorkingHoursDetails(this.dealerId,this.SelectedRadioButton);
        this.dealerWorkingHours.forEach(x =>{
            x.openingTimeHrs = (x.openingTimeHrs)?Utility.ConvertToTimeFormat(x.openingTimeHrs):"00:00";
            x.closingTimeHrs = (x.closingTimeHrs)?Utility.ConvertToTimeFormat(x.closingTimeHrs):"00:00";
            let openHour=x.openingTimeHrs.split(":");
            let closeHour=x.closingTimeHrs.split(":");
            x.openingTime = { hour: +openHour[0], minute:  +openHour[1] }
            x.closingTime = { hour: +closeHour[0], minute:  +closeHour[1] }
        })
        this.originalDealerWorkingHours = JSON.parse(JSON.stringify(this.dealerWorkingHours));
        this.spinner.hide();
    }

    async GetDealerLunchShiftDetails() {
        this.spinner.show();
        await this.dealerWorkingHoursService.GetDealerLunchShiftDetails(this.dealerId).then(result => {
          if (result.responseCode === fromEnums.ErrorCodes.SuccessCode && result.responseObject.length > 0) {
            this.lunchShift = result.responseObject[0];
            this.lunchShift.startTime = this.lunchShift.startTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.startTimeDate):"00:00";
            this.lunchShift.endTime = this.lunchShift.endTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.endTimeDate):"00:00";
            this.lunchShift.startTimeBreak1 = this.lunchShift.break1StartTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.break1StartTimeDate):"00:00";
            this.lunchShift.endTimeBreak1 = this.lunchShift.break1EndTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.break1EndTimeDate):"00:00";
            this.lunchShift.startTimeBreak2 = this.lunchShift.break2StartTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.break2StartTimeDate):"00:00";
            this.lunchShift.endTimeBreak2 = this.lunchShift.break2EndTimeDate?Utility.ConvertToTimeFormat(this.lunchShift.break2EndTimeDate):"00:00";
    
            let startTime=this.lunchShift.startTime.split(":");
            let endTime=this.lunchShift.endTime.split(":");
            let startTimeBreak1=this.lunchShift.startTimeBreak1.split(":");
            let endTimeBreak1=this.lunchShift.endTimeBreak1.split(":");
            let startTimeBreak2=this.lunchShift.startTimeBreak2.split(":");
            let endTimeBreak2=this.lunchShift.endTimeBreak2.split(":");
            this.lunchShift.lunchStartTime = { hour: +startTime[0], minute:  +startTime[1] }
            this.lunchShift.lunchEndTime = { hour: +endTime[0], minute:  +endTime[1] }
            this.lunchShift.break1StartTime = { hour: +startTimeBreak1[0], minute:  +startTimeBreak1[1] }
            this.lunchShift.break1EndTime = { hour: +endTimeBreak1[0], minute:  +endTimeBreak1[1] }
            this.lunchShift.break2StartTime = { hour: +startTimeBreak2[0], minute:  +startTimeBreak2[1] }
            this.lunchShift.break2EndTime = { hour: +endTimeBreak2[0], minute:  +endTimeBreak2[1] }
            this.originalLunchShift = JSON.parse(JSON.stringify(this.lunchShift));
            this.spinner.hide();
          }
          if (result.responseObject.length === 0 && result.responseCode.toString() === fromEnums.ErrorCodes.InvalidIdCode) {
            let errorMessage = this.translate.instant("lblInvalidDealerId");
            this.toastr.error(errorMessage);
          }
          this.spinner.hide();
        },
          _error => {
            this.spinner.hide()
          });
      }

      getstartHours(value: any, _model: any) {
        this.lunchShift.startTime = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
      }
    
      getendHours(value: any, _model: any) {
        this.lunchShift.endTime = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
      }
    
      getstartHoursBreak1(value: any, _model: any) {
        this.lunchShift.startTimeBreak1 = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
      }
    
      getendHoursBreak1(value: any, _model: any) {
        this.lunchShift.endTimeBreak1 = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
      }
    
      getstartHoursBreak2(value: any, _model: any) {
        this.lunchShift.startTimeBreak2 = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
      }
    
      getendHoursBreak2(value: any, _model: any) {
        this.lunchShift.endTimeBreak2 = (value.hour.toString().length===1? ("0"+value.hour) : value.hour) + ":" + (value.minute.toString().length===1? ("0"+value.minute) : value.minute) ;
      }

  OnClose(){
    this.activeModal.close({ success: true });
  }
}
